function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRobotChatFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.995 4.897a1 1 0 10-1.99.206 1 1 0 001.99-.206zM19 5a3 3 0 11-6 0 3 3 0 016 0zM2 25V14a4 4 0 014-4v2l-.204.01A2 2 0 004 14v11l.01.204a2 2 0 001.786 1.785L6 27h20l.204-.01a2 2 0 001.785-1.786L28 25V14a2 2 0 00-1.796-1.99L26 12v-2a4 4 0 014 4v11a4 4 0 01-4 4H6a4 4 0 01-3.995-3.794L2 25zm24-15v2H6v-2h20z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.995 17.898a1 1 0 10-1.99.205 1 1 0 001.99-.206zM12 18a3 3 0 11-6 0 3 3 0 016 0zM23.995 17.898a1 1 0 10-1.99.205 1 1 0 001.99-.206zM26 18a3 3 0 11-6 0 3 3 0 016 0zM11.125 22.517a1 1 0 011.267-.437l.091.045.248.13c1.312.657 3.722 1.348 6.833-.155l.095-.04a1 1 0 01.866 1.792l-.09.048c-3.81 1.842-6.881 1-8.594.146l-.324-.171-.087-.054a1 1 0 01-.305-1.304zM15 7h2v4h-2V7z",
    fill: props.color
  }));
}

export default SvgIconRobotChatFilled;